/* generated by pull.js */
import _import0 from "../addons/cat-blocks/_manifest_entry.js";
import _import1 from "../addons/editor-devtools/_manifest_entry.js";
import _import2 from "../addons/editor-searchable-dropdowns/_manifest_entry.js";
import _import3 from "../addons/data-category-tweaks-v2/_manifest_entry.js";
import _import4 from "../addons/block-palette-icons/_manifest_entry.js";
import _import5 from "../addons/hide-flyout/_manifest_entry.js";
import _import6 from "../addons/mediarecorder/_manifest_entry.js";
import _import7 from "../addons/drag-drop/_manifest_entry.js";
import _import8 from "../addons/debugger/_manifest_entry.js";
import _import9 from "../addons/pause/_manifest_entry.js";
import _import10 from "../addons/mute-project/_manifest_entry.js";
import _import11 from "../addons/clones/_manifest_entry.js";
import _import12 from "../addons/mouse-pos/_manifest_entry.js";
import _import13 from "../addons/color-picker/_manifest_entry.js";
import _import14 from "../addons/remove-sprite-confirm/_manifest_entry.js";
import _import15 from "../addons/block-count/_manifest_entry.js";
import _import16 from "../addons/onion-skinning/_manifest_entry.js";
import _import17 from "../addons/bitmap-copy/_manifest_entry.js";
import _import18 from "../addons/2d-color-picker/_manifest_entry.js";
import _import19 from "../addons/better-img-uploads/_manifest_entry.js";
import _import20 from "../addons/custom-block-shape/_manifest_entry.js";
import _import21 from "../addons/editor-theme3/_manifest_entry.js";
import _import22 from "../addons/custom-block-text/_manifest_entry.js";
import _import23 from "../addons/editor-colored-context-menus/_manifest_entry.js";
import _import24 from "../addons/editor-stage-left/_manifest_entry.js";
import _import25 from "../addons/variable-manager/_manifest_entry.js";
import _import26 from "../addons/search-sprites/_manifest_entry.js";
import _import27 from "../addons/gamepad/_manifest_entry.js";
import _import28 from "../addons/editor-sounds/_manifest_entry.js";
import _import29 from "../addons/folders/_manifest_entry.js";
import _import30 from "../addons/block-switching/_manifest_entry.js";
import _import31 from "../addons/load-extensions/_manifest_entry.js";
import _import32 from "../addons/custom-zoom/_manifest_entry.js";
import _import33 from "../addons/initialise-sprite-position/_manifest_entry.js";
import _import34 from "../addons/blocks2image/_manifest_entry.js";
import _import35 from "../addons/remove-curved-stage-border/_manifest_entry.js";
import _import36 from "../addons/transparent-orphans/_manifest_entry.js";
import _import37 from "../addons/paint-by-default/_manifest_entry.js";
import _import38 from "../addons/block-cherry-picking/_manifest_entry.js";
import _import39 from "../addons/hide-new-variables/_manifest_entry.js";
import _import40 from "../addons/editor-extra-keys/_manifest_entry.js";
import _import41 from "../addons/hide-delete-button/_manifest_entry.js";
import _import42 from "../addons/no-script-bumping/_manifest_entry.js";
import _import43 from "../addons/disable-stage-drag-select/_manifest_entry.js";
import _import44 from "../addons/move-to-top-bottom/_manifest_entry.js";
import _import45 from "../addons/disable-paste-offset/_manifest_entry.js";
import _import46 from "../addons/block-duplicate/_manifest_entry.js";
import _import47 from "../addons/swap-local-global/_manifest_entry.js";
import _import48 from "../addons/editor-comment-previews/_manifest_entry.js";
import _import49 from "../addons/columns/_manifest_entry.js";
import _import50 from "../addons/script-snap/_manifest_entry.js";
import _import51 from "../addons/fullscreen/_manifest_entry.js";
import _import52 from "../addons/tw-straighten-comments/_manifest_entry.js";
import _import53 from "../addons/tw-remove-backpack/_manifest_entry.js";
import _import54 from "../addons/tw-remove-feedback/_manifest_entry.js";
import _import55 from "../addons/tw-disable-compiler/_manifest_entry.js";
import _import56 from "../addons/editor-stepping/_manifest_entry.js";
export default {
  "cat-blocks": _import0,
  "editor-devtools": _import1,
  "editor-searchable-dropdowns": _import2,
  "data-category-tweaks-v2": _import3,
  "block-palette-icons": _import4,
  "hide-flyout": _import5,
  "mediarecorder": _import6,
  "drag-drop": _import7,
  "debugger": _import8,
  "pause": _import9,
  "mute-project": _import10,
  "clones": _import11,
  "mouse-pos": _import12,
  "color-picker": _import13,
  "remove-sprite-confirm": _import14,
  "block-count": _import15,
  "onion-skinning": _import16,
  "bitmap-copy": _import17,
  "2d-color-picker": _import18,
  "better-img-uploads": _import19,
  "custom-block-shape": _import20,
  "editor-theme3": _import21,
  "custom-block-text": _import22,
  "editor-colored-context-menus": _import23,
  "editor-stage-left": _import24,
  "variable-manager": _import25,
  "search-sprites": _import26,
  "gamepad": _import27,
  "editor-sounds": _import28,
  "folders": _import29,
  "block-switching": _import30,
  "load-extensions": _import31,
  "custom-zoom": _import32,
  "initialise-sprite-position": _import33,
  "blocks2image": _import34,
  "remove-curved-stage-border": _import35,
  "transparent-orphans": _import36,
  "paint-by-default": _import37,
  "block-cherry-picking": _import38,
  "hide-new-variables": _import39,
  "editor-extra-keys": _import40,
  "hide-delete-button": _import41,
  "no-script-bumping": _import42,
  "disable-stage-drag-select": _import43,
  "move-to-top-bottom": _import44,
  "disable-paste-offset": _import45,
  "block-duplicate": _import46,
  "swap-local-global": _import47,
  "editor-comment-previews": _import48,
  "columns": _import49,
  "script-snap": _import50,
  "fullscreen": _import51,
  "tw-straighten-comments": _import52,
  "tw-remove-backpack": _import53,
  "tw-remove-feedback": _import54,
  "tw-disable-compiler": _import55,
  "editor-stepping": _import56,
};
